module.exports = __webpack_public_path__ + "media/assets/certification_page/duration-icon-dcb1c377fa218a9a730df05c355183bf5beb0441fc64951e5444cf5ae3f2b41f.svg";